import { Reducer } from 'redux';

import { ISetDay, TActiveDay } from '../actions';
import { Days } from '../entities';
import { getCurrentDay } from '../../utils';

export type IActiveDayState = Days;

export const activeDayReducer: Reducer = (
  state: IActiveDayState = getCurrentDay(),
  action: ISetDay
): IActiveDayState => {
  switch (action.type) {
    case TActiveDay.SET_DAY:
      return action.payload;
    default:
      return state;
  }
};
